import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <Link to="/" className="logo">
          <img 
            src="/imgs/header-logo.png" 
            alt="Soprano Gráfica" 
            className="logo-image"
          />
          <span className="logo-text">Especialistas en la fabricación de envases en cartón microcorrugado, corrugado y cartulina</span>
        </Link>
        
        <nav className="nav">
          <a href="#empresa" onClick={(e) => { e.preventDefault(); scrollToSection('empresa'); }}>
            Empresa
          </a>
          <a href="#servicios" onClick={(e) => { e.preventDefault(); scrollToSection('servicios'); }}>
            Servicios
          </a>
          <a href="#productos" onClick={(e) => { e.preventDefault(); scrollToSection('productos'); }}>
            Productos
          </a>
          <a href="#procesos" onClick={(e) => { e.preventDefault(); scrollToSection('procesos'); }}>
            Procesos
          </a>
          <a href="#clientes" onClick={(e) => { e.preventDefault(); scrollToSection('clientes'); }}>
            Clientes
          </a>
          <a href="#contacto" onClick={(e) => { e.preventDefault(); scrollToSection('contacto'); }}>
            Contacto
          </a>
        </nav>

        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          ☰
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <a href="#inicio" onClick={(e) => { e.preventDefault(); scrollToSection('inicio'); }}>
            Empresa
          </a>
          <a href="#servicios" onClick={(e) => { e.preventDefault(); scrollToSection('servicios'); }}>
            Servicios
          </a>
          <a href="#productos" onClick={(e) => { e.preventDefault(); scrollToSection('productos'); }}>
            Productos
          </a>
          <a href="#procesos" onClick={(e) => { e.preventDefault(); scrollToSection('procesos'); }}>
            Procesos
          </a>
          <a href="#clientes" onClick={(e) => { e.preventDefault(); scrollToSection('clientes'); }}>
            Clientes
          </a>
          <a href="#contacto" onClick={(e) => { e.preventDefault(); scrollToSection('contacto'); }}>
            Contacto
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
